import { observable, observe, Lambda, IObjectDidChange, action, computed } from "mobx";
import { Parser } from "../../../Parser/Parser";
import * as i from "../../../contracts";
import { BaseBlockOptions, DeviceDetect } from "sb-resp-lib";

export class LeagueListPresenterState {
    public provider: Parser;
    public sportId: string;
    private disposerLeagues: Lambda;
    private disposerSelected: Lambda;
    private disposerIsLoading: Lambda;

    options: BaseBlockOptions;
    numberOfAllLeaguesShownByDefault: number;
    deviceDetect: DeviceDetect
    @observable shouldShowAllLeagues: boolean;

    @observable public leagues: i.League[];

    @observable selectedLeagues: string[];
    @observable isDataLoaded: boolean;
    @observable showAllButton: { label: string; expanded: boolean; };
    @observable selectedLeaguesLimitReached: boolean;
    @observable currentlySelectedLeague: string;

    constructor(provider: Parser, options: BaseBlockOptions) {
        this.provider = provider;
        this.leagues = this.provider.leagues.slice();
        this.selectedLeagues = this.provider.selectedLeagues.slice();
        this.options = options;
        this.numberOfAllLeaguesShownByDefault = this.options.cms.numberOfAllLeaguesShownByDefault;
        this.shouldShowAllLeagues = false;
        this.disposerLeagues = () => { };
        this.disposerSelected = () => { };
        this.disposerIsLoading = () => { };
        this.toggleSelectedLeague = this.toggleSelectedLeague.bind(this);
        this.openLeagueTranspiler = this.openLeagueTranspiler.bind(this);
        this.openCouponTranspiler = this.openCouponTranspiler.bind(this);
        this.sportId = "0";
        this.isDataLoaded = false;
        this.showAllButton = {
            label: this.options.dict.ShowAll,
            expanded: false
        }
        this.selectedLeaguesLimitReached = false;
        this.currentlySelectedLeague = "";
        this.deviceDetect = DeviceDetect.getInstance();
    }

    activate() {
        this.attachObservables();
        this.provider.activate();
    }

    /* istanbul ignore next */
    openLeagueTranspiler(sportId: string, leagueId: string, ev: React.SyntheticEvent, element: EventTarget) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenLeague(ev, leagueId, sportId, element);
    }

    /* istanbul ignore next */
    openCouponTranspiler(sportId: string, ev: React.SyntheticEvent) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenCoupon(sportId, this.selectedLeagues.slice());
    }

    deactivate() {
        this.provider.deactivate();
        this.detachObservable();
        this.clearData();
    }

    detachObservable(): any {
        this.disposerLeagues();
        this.disposerSelected();
        this.disposerIsLoading();
    }

    setParams(sportId: string, leagueIds?: string[]) {
        this.provider.selectRetriever(sportId, leagueIds);
        this.sportId = sportId;
    }
    @computed get getNumberOfLeaguesToRender() {
        return this.shouldShowAllLeagues
            ? this.leagues.length
            : this.numberOfAllLeaguesShownByDefault;
    }

    @computed get showBottomButton() {
        return this.shouldShowAllLeagues && this.selectedLeagues.length !== 0 &&
            this.options.cms.showCouponButtonBottom;
    }

    /* istanbul ignore next */
    attachObservables() {
        /* istanbul ignore next */
        this.disposerLeagues = observe(this.provider, (change: IObjectDidChange) => {
            this.updateLeagues(change);
        });

        this.disposerIsLoading = observe(this.provider, (change: IObjectDidChange) => {
            this.isDataLoaded = !change.object.isLoading;
        });

        this.disposerSelected = observe(this.provider, (change: IObjectDidChange) => {
            this.updateSelectedLeagues(change);
        });
    }
    /* istanbul ignore next */
    @action.bound
    updateLeagues(change: IObjectDidChange) {
        this.leagues = change.object.leagues;
    }
    /* istanbul ignore next */
    @action.bound
    updateSelectedLeagues(change: IObjectDidChange) {
        this.selectedLeagues = change.object.selectedLeagues;
    }
    /* istanbul ignore next */
    @action.bound
    toggleSelectedLeague(leagueId: string) {
        this.selectedLeaguesLimitReached = !this.provider.toggleSelectedLeague(leagueId);
        this.currentlySelectedLeague = leagueId;
        this.selectedLeaguesLimitReached && setTimeout(() => {
            this.selectedLeaguesLimitReached = false;
        }, 5000);
    }
    /* istanbul ignore next */
    @action.bound clearData() {
        this.leagues = observable([]);
    }

    /* istanbul ignore next */
    @computed get onlyTopLeagues() {
        return this.provider.getTopLeaguesOnly
    }

    /* istanbul ignore next */
    @action.bound showAllButtonHandler() {
        this.shouldShowAllLeagues = !this.shouldShowAllLeagues;
        this.showAllButton.expanded = !this.showAllButton.expanded;

        this.showAllButton.label = this.showAllButton.expanded ? this.options.dict.HideAll : this.options.dict.ShowAll;
    }
}
